import { EnvironmentVariablesModel } from './models/environment-variables.model';

export const environment: EnvironmentVariablesModel = {
    production: true,
    isStandalone: false,
    apiUri: '${BASE_API_URI}',
    hostUrl: '${HOST_URL}',
    oidcClientConfig: {
        authority: '${IAM_AUTHORITY}',
        clientId: '${IAM_CLIENT_ID}',
        extensions: {
            authInitializer: {
                enabled: true,
                mockOnDevelopment: false
            },
            interceptor: {
                enabled: true,
                ignoreResources: ['.json']
            }
        },
        postLogoutRedirectUri: '${IAM_POST_LOGOUT_REDIRECT_URI}',
        redirectUri: '${IAM_REDIRECT_URI}',
        scope: '${IAM_SCOPE}',
        silentAuth: {
            iframeScriptOrigin: '${HOST_URL}',
            redirectUri: '${IAM_SILENT_REDIRECT_URI}'
        }
    },
    securityLendingUrl: '${SECURITY_LENDING_URL}'
};
